import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import styled from 'foundations-theming/utils';
import { filterProps } from '../../../utils/filterProps';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledDL = styled.dl.withConfig({
  displayName: "DescriptionList__StyledDL",
  componentId: "sc-1lfg1yk-0"
})(({
  $cssStyles,
  theme
}) => {
  return Object.assign({
    margin: theme.space['0'],
    '& dt': Object.assign({
      color: theme.color['text-core-subtle']
    }, theme.typography['detail-200']),
    '& dd': Object.assign({
      marginInlineStart: theme.space['0'],
      marginBlockEnd: theme.space['300'],
      color: theme.color['text-core-default']
    }, theme.typography['body-100'])
  }, $cssStyles);
});
export const DescriptionList = _ref => {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(StyledDL, Object.assign({}, domProps, {
    $cssStyles: cssStyles,
    children: children
  }));
};